import moment from 'moment';

import { Payout } from 'types';

// TODO: rely on something else https://jira.zalando.net/browse/COLLAB-18034
export const isPromotionBudgetFinal = (
  campaignEndDate: null | string,
  now: moment.Moment
): boolean => (
  moment(campaignEndDate).add(2, 'days').isSameOrBefore(now.startOf('day'))
);

export const canReleasePayout = <P extends Pick<Payout, 'payoutType'>>(
  payout: P,
  campaignEndDate: null | string,
  now: moment.Moment
): boolean => {
  if (payout.payoutType === 'ccm_production') {
    return true;
  }

  return isPromotionBudgetFinal(campaignEndDate, now);
};
